import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Volume2,
  Shield,
  Gem,
  Users,
  Settings,
  CircleUserRound,
  CreditCard,
  MessageSquare,
  Megaphone,
  Flag,
  Sticker,
  Music,
  Wallet,
  Ticket,
} from "lucide-react";

import { useTheme } from "../context/ThemeContext";

const navLinks = [
  { icon: LayoutDashboard, text: "Dashboard", path: "/dashboard" },
  { icon: CircleUserRound, text: "User Management", path: "/user-management" },
  { icon: Megaphone, text: "Campaigns", path: "/campaigns" },
  { icon: Shield, text: "Badges", path: "/badges" },
  { icon: Gem, text: "Features", path: "/features" },
  { icon: CreditCard, text: "Transactions", path: "/transactions" },
  { icon: MessageSquare, text: "User Queries", path: "/user-queries" },
  { icon: Flag, text: "Reports", path: "/reports" },
  { icon: Sticker, text: "Stickers", path: "/stickers" },
  { icon: Music, text: "Music", path: "/music" },
  { icon: Wallet, text: "crypto", path: "/crypto" },
  { icon: Ticket, text: "coupon", path: "/coupon" },
  { icon: MessageSquare, text: "Chatbot", path: "/chatbot" }, // Added Chatbot Management
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDarkMode } = useTheme();

  const sidebarClasses = isDarkMode
    ? "bg-black border-zinc-900 text-white"
    : "bg-white border-gray-200 text-gray-900 shadow-xl";

  const logoSectionClasses = isDarkMode ? "border-zinc-900" : "border-gray-200";

  const logoTextClasses = isDarkMode ? "text-orange-400" : "text-orange-600";

  const scrollbarThumbClass = isDarkMode
    ? "scrollbar-thumb-zinc-800"
    : "scrollbar-thumb-gray-400";

  const getLinkClasses = (isActive) => {
    if (isDarkMode) {
      return isActive
        ? "bg-zinc-900 text-white font-semibold"
        : "text-gray-500 hover:bg-zinc-900 hover:text-white font-medium";
    } else {
      return isActive
        ? "bg-gray-100 text-gray-900 font-semibold"
        : "text-gray-600 hover:bg-gray-50 hover:text-black font-medium";
    }
  };

  const badgeClasses = isDarkMode
    ? "bg-orange-400 text-black"
    : "bg-orange-500 text-black";

  return (
    <aside
      className={`fixed left-0 top-0 h-screen w-64 flex flex-col overflow-hidden z-50 border-r transition-colors duration-300 ${sidebarClasses}`}
    >
      <div
        className={`flex flex-col items-center justify-center text-center py-8 px-5 border-b transition-colors duration-300 ${logoSectionClasses}`}
      >
        <img
          src="/SlayLogo.png"
          alt="Slay Logo"
          className="w-20 h-20 mb-3"
          onError={(e) => {
            e.target.style.display = "none";
            e.target.nextSibling.style.display = "flex";
          }}
        />
        <div className="w-20 h-20 bg-orange-400 rounded-full hidden items-center justify-center mb-3">
          <div className="text-3xl font-bold text-black">S</div>
        </div>
        <h1 className={`text-2xl font-bold ${logoTextClasses}`}>SLAY</h1>
      </div>

      <nav
        className={`flex-1 overflow-y-auto px-4 py-6 sidebar-scrollbar ${!isDarkMode ? 'light-mode' : ''}`}
      >
        <ul className="space-y-2">
          {navLinks.map((link) => {
            const Icon = link.icon;
            const isActive = location.pathname === link.path;

            return (
              <li key={link.text}>
                <button
                  onClick={() => navigate(link.path)}
                  className={`w-full flex items-center gap-4 py-3 px-4 rounded-lg transition-colors duration-200 ${getLinkClasses(
                    isActive
                  )}`}
                >
                  <Icon size={22} />
                  <span className="flex-grow text-left">{link.text}</span>
                  {link.badge && (
                    <span
                      className={`${badgeClasses} text-xs font-bold px-2 py-0.5 rounded-full`}
                    >
                      {link.badge}
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
